/**
 * useMobileOptimization.ts
 * Hook pour utiliser MobileOptimizationService dans les composants React
 */
import { useEffect, useState } from 'react';
import {
  MobileOptimizationService,
  mobileOptimizationsCSS,
} from '../services/MobileOptimizationService';

/**
 * Hook pour gérer les optimisations mobiles
 */
export function useMobileOptimization() {
  const [mobileService] = useState(() => MobileOptimizationService.getInstance());
  const [isMobile, setIsMobile] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [viewportSize, setViewportSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    // Injecter le CSS d'optimisation mobile
    const styleId = 'mobile-optimizations-css';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = mobileOptimizationsCSS;
      document.head.appendChild(style);
    }

    // Mettre à jour les états
    const updateStates = () => {
      setIsMobile(mobileService.isMobileDevice());
      setIsTouchDevice(mobileService.getIsTouchDevice());
      setViewportSize(mobileService.getViewportSize());
    };

    updateStates();

    // Écouter les changements de taille
    const handleResize = () => {
      updateStates();
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Optimiser le canvas pour mobile
    mobileService.optimizeCanvasForMobile();

    // Activer le mode hors ligne
    mobileService.enableOfflineMode();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [mobileService]);

  return {
    isMobile,
    isTouchDevice,
    viewportSize,
    service: mobileService,
  };
}
